import React, { useEffect, useState } from "react";

import AWS from "aws-sdk";

import Moment from "moment";

import Select from "react-select";
import {
  getTeams,
  profileImageUpload,
  userProfileUpdate,
} from "../../../services/MainApiDetails";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import DefaultImg from "../../../assets/img/avatar-face.jpg";
// import DefaultImg from "../../../avatar-face.jpg";

import profile_image from "../../../utilities/constants.json";
// import profile_image from "../../utilities/constants.json";

import EditIcon from "../../../assets/icon/Edit.svg";

import LanguageSwitch from "../../settings/components/LanguageSwitch";

import constants from "../../../utilities/constants.json";

const PhotoAndTeam = () => {
  const [teams, setTeams] = useState("");
  const [options, setOptions] = useState([]);
  const [favTeam, setFavTeam] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [imageUrl, setImageUrl] = useState(profile_image.profile_image);
  const [imageName, setImageName] = useState("");
  const [language, setLanguage] = useState("");
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getTeamCountries();
  }, []);

  function getTeamCountries() {
    getTeams({})
      .then((res) => {
        if (res.data.status === 1) {
          setTeams(res.data.data);
          let team_countries = res.data.data;
          settingTeam(team_countries);
        }
      })
      .catch((err, message) => {
        console.log(err + message);
      });
  }

  function settingTeam(teaming) {
    let optionData = [];
    teaming.map((item) => {
      optionData.push({ value: item._id, label: item.team_name });
    });
    setOptions(optionData);
    // console.log(options);
  }

  // console.log("OPTION");
  // console.log(options);
  // console.log("OPTIONs");

  // function favoriteTeamSelection(e) {
  //   let val = e.target.value;
  //   console.log(val);
  //   setFavTeam(val);
  //   console.log(favTeam);
  // }

  // console.log("FAVORITE TEAM");
  // console.log(favTeam);

  // Language Switching
  function changeLanguage(value) {
    setLanguage(value);
    localStorage.setItem("language", value);
    userProfileUpdate({
      language: value,
    })
      .then((res) => {
        console.log(res);
      })
      .catch((e) => {
        console.log(e);
      });
    // window.location.reload();
  }

  // ++++++++++++++ IMAGE UPLOADING +++++++++++++++++++++++

  const [imageFile, setImageFile] = useState();

  function imageFileFunc(e) {
    setProfileImage(e.target.files);
    // setProfileImage(e.target.files);
    // setProfileImage(e.target.files);
    // setProfileImage(e.target.files);
    setImageFile(URL.createObjectURL(e.target.files[0]));
  }

  function submitImgTeamFunc(e) {
    e.preventDefault();
    let file = profileImage[0];

    setLoading(true);
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result;

        const data = { image: base64String, team_id: favTeam.value, };
        profileImageUpload(data)
          .then((response) => {
            if (response.data.status === 1) {
              navigate("/");
            }
          })
          .catch((err) => {
            console.error(err);
          }).finally(()=>{
            setLoading(false);
          });
      };

      reader.readAsDataURL(file);
    } else {
      // alert("Please add an image!");
      if (favTeam.value) {
        let data;

        data = {
          team_id: favTeam.value,
        };

        profileImageUpload(data)
          .then((response) => {
            console.log(response);
            if (response.data.status === 1) {
              console.log(response);
              setLoading(false);

              // window.location.href = "/";
            }
          })
          .catch((err, message) => {
            console.log(err + message);
          });
        if (loading == false) {
          window.location.href = "/";
        }
      } else {
        alert("Please add image or team!");
      }
    }
  }

  // ++++++++++++++ IMAGE UPLOADING +++++++++++++++++++++++

  return (
    <div className="mobileRegister-form-bottom">
      <form action="" enctype="multipart/form-data">
        <div className="mobileRegister-input-wrapper">
          <div className="mobileRegister-image-inputBox">
            {imageFile ? (
              <div className="mobileRegister-profileImg-wrapper">
                <img src={imageFile ? imageFile : DefaultImg} alt="" />
              </div>
            ) : (
              <label for="inputTag">
                <div className="image-upload-wrapper">
                  <div className="image-text-wrapper">
                    <p className="plus">+</p>
                    <p>add</p>
                    <p>profile photo</p>
                  </div>

                  <input
                    id="inputTag"
                    type="file"
                    accept="image/png, image/jpg, image/jpeg"
                    onChange={(e) => imageFileFunc(e)}
                    // onChange={(e) => setProfileImage(e.target.files)}
                  />
                </div>
              </label>
            )}
            {imageFile ? (
              <div className="mobileRegister-image-inputBox-pencil">
                <label for="inputTag">
                  <div className="image-upload-wrapper-pencil">
                    <div className="image-text-wrapper">
                      <img src={EditIcon} alt="" />
                    </div>
                    <input
                      id="inputTag"
                      type="file"
                      accept="image/png, image/jpg, image/gif, image/jpeg"
                      onChange={imageFileFunc}
                    />
                  </div>
                </label>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="mobileRegister-select-inputBox">
            {/* <span>Your favuorite team</span> */}
            <Select
              options={options}
              value={favTeam}
              onChange={(e) => setFavTeam(e)}
              placeholder="Choose your favourite team"

              // menuPlacement="top"
            />
          </div>
        </div>
        <div className="laguageSwitch-wrapper">
          {/*<LanguageSwitch changeLanguage={changeLanguage1} />*/}
          <div className="mobileSettings-languageSwitch-wrapper">
            <p className="switch-text">Switch your questions language</p>
            <div className="language-switchBtn-wrapper">
              <button
                type="button"
                className={
                  localStorage.language != "en" || language == "ml"
                    ? "switch-btn-selected"
                    : "switch-btn"
                }
                onClick={() => changeLanguage("ml")}
              >
                MALAYALAM
              </button>
              <button
                type="button"
                className={
                  localStorage.language == "en" || language == "en"
                    ? "switch-btn-selected"
                    : "switch-btn"
                }
                onClick={() => changeLanguage("en")}
              >
                ENGLISH
              </button>
            </div>
          </div>
        </div>
        <div className="mobileRegister-terms-text">
          <p>
            <Link to="/">SKIP</Link>
          </p>
        </div>
        <div className="mobileRegister-signup-button">
          {/* <button onClick={submitImgTeamFunc}>START TO PREDICT</button>

          <button>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading
          </button> */}

          <button onClick={submitImgTeamFunc}>
            {loading && (
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            {loading && (
              <span style={{ marginLeft: "10px" }}>START TO PREDICT</span>
            )}
            {!loading && <span>START TO PREDICT</span>}
          </button>

          {/* <button class="btn btn-primary" type="button" disabled>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button> */}
        </div>
      </form>
    </div>
  );
};

export default PhotoAndTeam;
